import state from './healthcheckeventlog.state'
import mutations from './healthcheckeventlog.mutations'
import actions from './healthcheckeventlog.actions'

export default {
  state,
  mutations,
  actions
}
